import { TableauDashboardAccess } from '@studyportals/crm-data-processor-interface';

// eslint-disable-next-line @typescript-eslint/naming-convention
const ActClientProductPayment = {
	FREE: "free",
	PAID: "paid"
} as const;

type ActClientProductPaymentType = (typeof ActClientProductPayment)[keyof typeof ActClientProductPayment];

type DashboardDetailsType = {
	tag: string;
}

type DashboardAccessItem = TableauDashboardAccess & {
	type: ActClientProductPaymentType;
}

export { DashboardDetailsType, DashboardAccessItem, ActClientProductPayment, ActClientProductPaymentType };
